<template>
  <a class="blue-box" :href="href"><slot /></a>
</template>

<script>
export default {
  props: ["href"],
};
</script>

<style lang="scss" scoped>
a.blue-box {
  color: white;
  font-size: 14px;
  background: $dark-blue;
  font-family: Montserrat;
  font-weight: 800;
  padding: 2rem 2rem;
  transition: background-color 0.25s ease-out;
  display: block;
  letter-spacing: 3px;
  text-align: center;
  width: 100%;
  text-transform: uppercase;

  &:hover {
    background: $primary-blue;
  }
}
</style>
